import { notifyAckApi } from '@/api/notify'
import { NotifyAckKind } from '@/enums/chat'
import type { notifyAckRequest } from '@/api/notify/types'
import { toastify } from '@/utils'

/**
 * 通知已读 Composable
 * 提供统一的通知已读处理方法
 */
export function useNotifyAck() {
  /**
   * 标记通知已读（仅需要 kind 参数）
   * @param kind 通知类型
   * @param showSuccess 是否显示成功提示，默认 false
   */
  const ackNotify = async (kind: NotifyAckKind, showSuccess = false) => {
    try {
      await notifyAckApi({ kind })
      if (showSuccess) {
        toastify({ message: '操作成功', type: 'success' })
      }
    } catch (error) {
      console.error('标记通知已读失败:', error)
      toastify({ message: '操作失败', type: 'danger' })
      throw error
    }
  }

  /**
   * 标记通知已读（需要额外参数）
   * @param params 完整的请求参数
   */
  const ackNotifyWithParams = async (params: notifyAckRequest) => {
    try {
      await notifyAckApi(params)
    } catch (error) {
      console.error('标记通知已读失败:', error)
      throw error
    }
  }

  return {
    ackNotify,
    ackNotifyWithParams,
  }
}
